import React, { Suspense } from 'react';
import { USER_ROLES } from '../../config/constants';
import IRoute from '../../interface/IRoute';

const LazyDashboardComponent = React.lazy(() => import('./designer-dashboard/designer-dashboard.component'));
const LazyPatientsComponent = React.lazy(() => import('./patients/patients.component'));
const LazySubmitDesignComponent = React.lazy(() => import('./submit-design/submit-design.component'));
const LazyProfileComponent = React.lazy(() => import('./profile/profile.component'));

const LoadingFallback = () => <div>Loading...</div>;

const designerRoutes: IRoute[] = [
  {
    path: '/designer',
    exact: true,
    name: 'Dashboard',
    key: 'dashboard_page',
    component: () => (
      <Suspense fallback={LoadingFallback}>
        <LazyDashboardComponent />
      </Suspense>
    ),
    role: USER_ROLES.DESIGNER,
  },
  {
    path: '/designer/patients',
    exact: false,
    name: 'Patients',
    key: 'patients_page',
    component: () => (
      <Suspense fallback={LoadingFallback}>
        <LazyPatientsComponent />
      </Suspense>
    ),
    role: USER_ROLES.DESIGNER,
  },
  {
    path: '/designer/profile',
    exact: true,
    name: 'Profile',
    key: 'profile_page',
    component: () => (
      <Suspense fallback={LoadingFallback}>
        <LazyProfileComponent />
      </Suspense>
    ),
    role: USER_ROLES.DESIGNER,
  },
  {
    path: '/designer/patients/:caseId/submit-design',
    exact: true,
    name: 'Submit Design Page',
    key: 'submit_design_page',
    component: () => (
      <Suspense fallback={LoadingFallback}>
        <LazySubmitDesignComponent />
      </Suspense>
    ),
    role: USER_ROLES.DESIGNER,
  },
  // {
  //     path: '/patients/:caseId/proposals/:proposalId',
  //     exact: true,
  //     name: 'Proposal Detail Page',
  //     key: 'proposal_detail_page',
  //     component: ProposalDetailsPage
  // },
  // {
  //     path: '/patients/case/submit-case',
  //     exact: true,
  //     name: 'Submit Case',
  //     key: 'submit_case',
  //     component: SubmitCasePage
  // },
  // {
  //     path: '/patients/case/submit-design/:caseId',
  //     exact: true,
  //     name: 'Submit New Design',
  //     key: 'submit_new_design',
  //     component: submitNewDesign
  // },
];

export default designerRoutes;
